export const SET_EMAILTEMPLATE = 'EMAILTEMPLATE/SET_EMAILTEMPLATE'
export const SET_EMAILTEMPLATES = 'EMAILTEMPLATE/SET_EMAILTEMPLATES'
export const SET_COPIED_TEMPLATE = 'EMAILTEMPLATE/SET_COPIED_TEMPLATE'
